import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import Button from '../../../../components/Button/Button';
import generateRender from 'shared/utils/generateRender';
import { pwaStyleAdapter } from '../../../../utils/mobileSupported';

function FormButtonDefault(props) {
  const { isLandingPage, disabled } = props;
  return (
    <Button
      imageStyle={isLandingPage ? { width: pwaStyleAdapter(15, 'em') } : null}
      label={FormButtonText()}
      imageSource={
        !disabled
          ? isLandingPage
            ? assetSource(ASSET_KEY.GREEN_BUTTON_LANDING)
            : assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)
          : isLandingPage
            ? assetSource(ASSET_KEY.GREY_BUTTON_LANDING)
            : assetSource(ASSET_KEY.ROUNDED_RECT_DISABLED)
      }
      {...props}
    />
  );
}

const FormButtonText = () =>
  generateRender({
    default: getText(TEXT_KEY.REGISTER),
  });

const FormButton = generateRender({
  default: FormButtonDefault,
});

export default FormButton;

